<template>
    <div>
        <el-form :model="singForm" ref="singForm" label-position="top" label-width="120px">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="RFC"
                                  prop="rfc"
                                  :rules="[{ required: true, message: 'Este campo es obligatorio',trigger: 'change'},
                                  {pattern:/^([A-Z]{4,4})([0-9]{6,6})([A-Z0-9]{3,3})$/,message: 'Formato inválido', trigger: 'blur'},
                                  { max: 20, message: 'Este campo debería ser de máximo 20 caracteres', trigger: 'blur' }]">
                        <el-input v-my-only-alphanumeric="{maxChars: 20}" :maxlength="20" v-model="singForm.rfc"/>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Contraseña"
                                  prop="password"
                                  :rules="[{required: true,message: 'Este campo es obligatorio',trigger: 'change'},]">
                        <el-input show-password v-model="singForm.password"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <br>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item
                        :rules="{ required: true,
                                     message: 'Este campo es obligatorio',
                                     trigger: 'change'}">
                        <el-upload
                            class="files-to-upload"
                            :before-upload="beforeUploadKey"
                            ref="upload"
                            action="/api/upload-fiel"
                            :headers="{'Authorization': apiToken}"
                            :limit="1"
                            :file-list="key"
                            accept=".key"
                            :auto-upload="true"
                            :on-exceed="showDeleteMessage"
                            :before-remove="removeFile"
                            :on-success="uploadedFiel"
                            :on-error="onErrorFiel">
                            <el-button
                                style="width: 100%!important"
                                slot="trigger"
                                type="primary">
                                Seleccionar archivo .key
                            </el-button>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item>
                        <el-upload
                            class="files-to-upload"
                            :before-upload="beforeUploadCer"
                            ref="upload"
                            action="/api/upload-fiel"
                            :headers="{'Authorization': apiToken}"
                            :limit="1"
                            :file-list="cer"
                            accept=".cer"
                            :auto-upload="true"
                            :on-exceed="showDeleteMessage"
                            :before-remove="removeFile"
                            :on-success="uploadedFiel"
                            :on-error="onErrorFiel">
                            <el-button
                                style="width: 100%!important"
                                slot="trigger"
                                type="primary">
                                Seleccionar archivo .cer
                            </el-button>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-row :gutter="20">
            <el-col :span="24" align="end">
                <el-button
                    type="success"
                    size="mini"
                    icon="far fa-save"
                    @click="saveFiel">
                    Guardar
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    export default {
        props: {
            modal: {}
        },

        data() {
            return {
                singForm: {
                    rfc: '',
                    password: '',
                    cer: null,
                    key: null
                },
                apiToken: null,
                cer: [],
                key: [],
                fiel: []
            }
        },

        watch: {
            'singForm.rfc'() {
                this.singForm.rfc = this.singForm.rfc != null ? this.singForm.rfc.toUpperCase() : null;
            },
        },

        computed: {
            ...mapGetters('utils', {
                userRequest: "userRequest",
            }),
        },

        mounted() {
            this.apiToken = 'Bearer ' + window.sessionStorage.getItem('sipac_token');

        },

        methods: {
            beforeUploadKey(file) {
                let _this = this;
                const isKey = file.name.match('.key') === null ? false : true;

                if (!isKey) {
                    this.$message.error('Seleccione el archivo e.Firma con formato .key');
                }
                return isKey;
            },
            beforeUploadCer(file) {
                let _this = this;
                const isCer = file.type === 'application/x-x509-ca-cert';

                if (!isCer) {
                    this.$message.error('Seleccione el archivo e.Firma con formato .cer');
                }
                return isCer;
            },
            showDeleteMessage() {
                this.$message({
                    type: 'warning',
                    message: 'Para seleccionar otro archivo elimine de la lista el cargado anteriormente.',
                });
            },
            removeFile(file) {
                if (file.response !== undefined) {
                    const id = file.response.id;
                    for (var i = this.fiel.length - 1; i >= 0; i--) {
                        if (this.fiel[i].id === id) {
                            this.fiel.splice(i, 1);
                        }
                    }
                }
            },
            uploadedFiel(data) {
                // Archivo .key
                if (data.cat_file_type_id == 1) {
                    this.fiel.push(data);
                }
                // Archivo .cer
                if (data.cat_file_type_id == 2) {
                    if (data.isValid == true) {
                        this.fiel.push(data);
                    } else {
                        this.$message({
                            type: 'warning',
                            message: 'La e.Firma indicada ya no se encuentra vigente, seleccione una válida.',
                        });
                    }
                }
            },
            onErrorFiel(err, file, fileList) {
                this.$message({
                    type: 'warning',
                    message: 'No fue posible leer el archivo .key o .cer, inténtelo nuevamente.',
                });
            },
            editFiel() {
                if (this.editFielEnabled == true) {
                    this.editFielEnabled = false;
                    this.editFielForm = true;
                    this.fiel = [];
                } else {
                    this.editFielEnabled = true;
                    this.editFielForm = false;
                    this.getUserInfo();
                }
            },
            saveFiel() {
                if (this.fiel != null && this.fiel.length > 1) {
                    this.$refs['singForm'].validate(valid => {
                        if (valid) {
                            this.singForm.password = btoa(this.singForm.password);
                            this.showLoading();
                            axios.post('/api/save-fiel', {
                                userId: window.sessionStorage.getItem('sipac_token'),
                                fiel: this.$data.fiel,
                                dataFiel: this.singForm
                            }).then(response => {
                                response.data.success = true;
                                if (response.data.success) {
                                    /* this.getUserInfo();
                                     this.clearFielData();*/
                                    this.$message({
                                        type: 'success',
                                        message: 'La e.Firma se guardó con éxito.',
                                    });
                                    this.userRequest.modal = false;
                                    this.hideLoading();
                                } else {
                                    this.singForm = {
                                        rfc: '',
                                            password: '',
                                            cer: null,
                                            key: null
                                    };
                                    this.fiel = [];
                                    this.$message({
                                        type: 'warning',
                                        message: 'Hubo un error al validar el certificado, valide sus datos.',
                                    });
                                    this.userRequest.modal = false;
                                    this.hideLoading();
                                }
                            }).catch(error => {
                                this.singForm = {
                                    rfc: '',
                                    password: '',
                                    cer: null,
                                    key: null
                                };
                                this.fiel = [];
                                this.hideLoading();
                                this.$message({
                                    type: 'warning',
                                    message: 'No fue posible guardar los archivos, inténtelo nuevamente.',
                                });
                                this.userRequest.modal = false;
                                this.hideLoading();
                            });
                        } else {
                            this.$message.warning('Capture todos los campos obligatorios.');
                        }
                    });
                } else {
                    this.$message({
                        type: 'warning',
                        message: 'Por favor seleccione los archivos .key y .cer o remueva los archivos de la lista para repetir el proceso.',
                    });
                    return false;
                }
            },

            showLoading(message) {
                this.$store.dispatch(
                    'loading/spinner',
                    {msg: message, status: true},
                    {root: true}
                );
            },
            hideLoading() {
                this.$store.dispatch('loading/spinner', {}, {root: true});
            },
        }
    }
</script>

<style scoped>

</style>
